<template>
  <div class="studymain" @click="showTip = false">
    <audio ref="audio" autoplay controls :src="currentWord[sound + 'fy']"
           style="width: 0;height: 0;position: absolute;top: 0;">您的浏览器不支持 audio 标签。
    </audio>
    <studyHeader @back="back"/>
    <feedBack ref="handleWrong"/>
    <el-drawer
        title="有什么想询问的单词呢?"
        :visible.sync="showModal"
        :size="drawerSize"
        direction="ltr"
        @close="closeModal"

    >
      <iframe :src="iframeSrc" width="500px" height="100%"></iframe>
    </el-drawer>
    <div class="studyBox" id="studyIpad">
      <img src="../../../assets/images/teacher/苗.gif" alt=""
           class="doumiao"
           @click="feedBackFn">
      <img src="../../../assets/images/teacher/狐狸.gif" alt=""
           class="huli"
           @click="openModal">
      <div class="main" v-if="content !== 'test'">
        <!-- 收藏功能 -->
        <div class="squirrel" v-if="source === 'studyway' && content == 'default'">
          <img :src='"../../../assets/images/student/" + (currentWord.sfsc ? "no" : "") + "squirrel.png"' alt=""
               @click="collect(currentWord.sfsc)">
        </div>
        <!-- 头部 -->
        <div class="unitsTitle">
          <img src="../../../assets/images/student/unitsTitle.png" alt="">
          <div class="text">学习内容</div>
        </div>
        <!-- 初始 -->
        <div class="default" v-if="content == 'default'">
          <div class="progress">
            <el-progress :text-inside="true" :stroke-width="16"
                         :percentage="(currentIndex + 1) / wordList.length * 100"></el-progress>
            <div class="text">{{ currentIndex + 1 + '/' + wordList.length }}</div>
          </div>
          <div class="word" :class="wordSizeClass">{{ currentWord.nr }}</div>
          <div class="audio">
            <img src="../../../assets/images/student/horn.png" alt="" @click="play">
          </div>
          <div class="mean">{{ currentWord[sound + 'yb'] }}</div>
          <div class="btns">
            <div class="btnleft left" @click="isShuxi(1)">
              <img src="../../../assets/images/student/cooked.png" alt="">
              <span class="btntext">熟悉</span>
            </div>
            <div class="btnright right" @click="isShuxi(0)">
              <img src="../../../assets/images/student/Unfamiliar.png" alt="">
              <span class="btntext">不熟悉</span>
            </div>
          </div>
        </div>
        <!-- 第一轮测试 -->
        <div class="test1" v-if="content == 'test1'">
          <div class="header">
            <div class="title">请选择正确的词义</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <div class="wordaudio">
            <div class="word">{{ currentWord.nr }}
              <div class="img" @click="play">
                <img src="../../../assets/images/student/horn.png" alt="">
              </div>
            </div>
          </div>
          <div class="options">
            <div class="option" v-for="item in optionsChinese" :key="item">
              <div class="answer" @click="doTest1(item)"
                   :style="ansYes === item ? 'background: #8BDF1F;color: #fff;' : (ansNo === item ? 'background: #FF4545;color: #fff;' : '')">
                {{ item }}
                <!-- 正确 -->
                <div class="icon" v-if="ansYes === item">
                  <img src="../../../assets/images/student/right.png" alt="">
                </div>
                <!-- 错误 -->
                <div class="icon" v-if="ansNo === item">
                  <img src="../../../assets/images/student/Wrong.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 学习 -->
        <div class="study" v-if="content == 'study'">
          <div class="progress">
            <el-progress :text-inside="true" :stroke-width="16"
                         :percentage="(currentIndex + 1) / wordList.length * 100"></el-progress>
            <div class="text">{{ currentIndex + 1 + '/' + wordList.length }}</div>
          </div>
          <div class="wordaudio">
            <div class="word">{{ currentWord.nr }}
              <div class="img" @click="play">
                <img src="../../../assets/images/student/horn.png" alt="">
              </div>
            </div>
          </div>
          <!-- 套红字母 -->
          <div class="overprint">
            <p><span v-for="(data, index) in toRed" :key="data + index"
                     :style="['a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U'].indexOf(data) !== -1 ? 'color: #FD3F3F' : ''">{{
                data
              }}</span></p>
          </div>
          <!-- 词义，可滚动 -->
          <div class="mean">
            <div class="menuoptions">
              <div class="every">
                <!-- 前四个  -->
                <div class="topfoue">
                  <p> {{ sound == 'yg' ? '[英]' : '[美]' }} {{ currentWord[sound + 'yb'] }} </p>
                  <p>{{ currentWord.cy }}</p>
                </div>
                <div class="association">{{ currentWord.sjf || '无' }}</div>
              </div>
            </div>
          </div>
          <div class="btns" @click="content = 'test1'">
            <img src="../../../assets/images/student/cooked.png" alt="">
            <span class="text">继   续</span>
          </div>
        </div>
        <!-- 第二轮测试 -->
        <div class="test2" v-if="content == 'test2'">
          <!-- 头 -->
          <div class="header">
            <div class="title">看义拼词</div>
            <p class="time"> 剩余 <span>{{ time }}</span> 秒 </p>
          </div>
          <!-- 词义 -->
          <div class="mean">
            <span :title="currentWord.cy" @click.stop="showAll(currentWord.cy)"> {{ currentWord.cy }} </span>
          </div>
          <div class="options2">
            <div class="center">
              <div v-for="data in optionSelected" :key="data.txt" class="option2">{{ data.txt }}</div>
              <div class="del" @click="delAll" :style="optionSelected.length > 0 ? 'display:block;' : 'display:none;'">
                <i class="el-icon-circle-close"></i></div>
            </div>
          </div>
          <hr class="hr">
          <div class="answers2">
            <div class="answer2"
                 :class="{ selected: optionSelected.map((ele) => {return ele.index }).indexOf(index) !== -1 }"
                 v-for="(data, index) in optionAns" :key="data" @click="selected(data, index)">
              {{ data }}
            </div>
          </div>
          <div class="btns" @click="submit">
            <img src="../../../assets/images/student/cooked.png" alt="">
            <span class="text">提交</span>
          </div>
        </div>
      </div>
      <!-- 开始测试 -->
      <div class="test" v-if="content == 'test'">
        <div class="congratulations">
          <div class="image">
            <img src="../../../assets/images/student/congratulations.png" alt="">
            <em class="text">
              完成本次学习,快去测试看看吧!
            </em>
          </div>
        </div>
        <!-- 测试按钮 -->
        <div class="practice" @click="toTest">
          <img src="../../../assets/images/student/practice.png" alt="">
          <span class="text">开始测试</span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogMsg" class="dialogMsg">
      <div class="dio">
        <img src="../../../assets/images/student/no1.png" v-if="dioAnswer == 'no1'" alt="">
        <img src="../../../assets/images/student/yes1.png" v-if="dioAnswer == 'yes1'" alt="">
        <div class="title" v-if="dioAnswer === 'no1'">正确答案</div>
        <div class="dioWord">{{ currentWord.nr }}</div>
        <!-- 加空白标签防止样式变性 -->
        <!-- <div class="dioWord" v-if="dioAnswer == 'yes1'"></div> -->
      </div>
    </el-dialog>
    <!-- <div class="showall" id="showall" @click.stop="showTip = true" v-show="showTip"></div> -->
  </div>
</template>
<script>
import {saveMyBreakpoint, getWords, updateCollectionWord, getMyBreakpoint} from '@/api/student'

export default {
  computed: {
    toRed() {
      return this.currentWord.dccf ? this.currentWord.dccf.split(',').join('-') : []
    },
    optionsChinese() {
      let arr = this.currentWord.yyh.split('##')
      arr.push(this.currentWord.cy)
      arr.sort(() => Math.random() - 0.5)
      return arr
    },
    // 根据单词/短语长度返回缩放类，避免长短语出现省略号或换行
    wordSizeClass() {
      let len = (this.currentWord.nr || '').length
      if (len > 20) return 'xlong'
      if (len > 12) return 'long'
      return ''
    }
  },
  components: {
    studyHeader: (resolve) => {
      require(["@/components/student/studyHeader"], resolve)
    },
    feedBack: (resolve) => {
      require(["@/components/feedback"], resolve)
    }
  },
  data() {
    return {
      content: '', // test完成 // default初始 // study学习 // test1第一轮测试 // test2第二轮测试
      wordList: [], // 单词列表
      currentWord: {}, // 当前单词
      currentIndex: 0, // 当前单词的索引
      submitData: {}, // 学习阶段产生的数据汇总
      clickStop: false, // 防高频点击
      sound: '', // 发音
      time: 20, // 倒计时
      timer: null, // 计时器
      ansYes: '', // 正确答案展示
      ansNo: '', // 错误答案展示
      optionSelected: [], // 看义拼词答案
      optionAns: [], // 看义拼词选项
      dialogMsg: false,
      dioAnswer: '', // 对的穿yes1  错的传no1
      source: '', // 来源 studyway学习之旅 wrong错词本
      backPath: '', // 返回上一页的地址
      showTip: false, // 控制showAll显示隐藏--文字超出时点击显示
      linkClick: true,
      showModal: false,   // 控制弹框显示
      iframeSrc: '',      // iframe 的 src 地址
      drawerSize: '520px'
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  mounted() {
    this.updateDrawerSize();
    window.addEventListener('resize', this.updateDrawerSize);
  },
  created() {
    this.wordList = JSON.parse(sessionStorage.getItem('words'))
    this.source = this.$route.query.source
    this.sound = localStorage.getItem('sound_' + this.$store.state.userInfo.realname)
    if (this.source === 'studyway') {
      this.backPath = '/wordcontent?type=' + this.$route.query.type + '&bbid=' + this.$route.query.bbid + '&zid=' + this.$route.query.zid + '&zmc=' + this.$route.query.zmc + '&dyid=' + this.$route.query.dyid + '&source=' + this.$route.query.source + '&lxid=' + this.$route.query.lxid
      getMyBreakpoint({
        dyid: ~~this.$route.query.dyid,
        cjid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
        xsid: this.$store.state.userInfo.yhid,
        cjlx: 1,
      }).then(res => {
        if (res.success) {
          let notes = res.resultDesc === 'SUCCESS' ? '' : res.resultDesc
          if (notes) {
            this.submitData = JSON.parse(notes)
            this.submitData.startTime = new Date().getTime()
            if (this.submitData.list.length === this.wordList.length) {
              this.content = 'test'
            } else {
              this.currentIndex = this.submitData.list.length
              this.nextItem(this.currentIndex)
            }
          } else {
            let jxInfo = JSON.parse(sessionStorage.getItem('jxInfo'))
            this.submitData = {
              progress: 0,
              xsxm: this.$store.state.userInfo.realname,
              xb: Number(JSON.parse(sessionStorage.getItem('userInfo')).xb),
              bbid: Number(this.$route.query.bbid),
              bbmc: JSON.parse(sessionStorage.getItem('bbInfo')).find(ele => {
                if (ele.bbid === Number(this.$route.query.bbid)) {
                  return ele
                }
              }).bbmc,
              bjid: jxInfo.bjid,
              bjmc: jxInfo.bjmc,
              dyid: Number(this.$route.query.dyid),
              cjr: this.$store.state.userInfo.yhid,
              dymc: jxInfo.dymc,
              jxid: jxInfo.jxid,
              jxmc: jxInfo.jxmc,
              xsid: this.$store.state.userInfo.yhid,
              zid: Number(this.$route.query.zid),
              zmc: jxInfo.zmc || this.$route.query.zmc,
              lxid: this.$route.query.lxid,
              lxmc: this.$route.query.type,
              list: [],
              startTime: new Date().getTime(),
              xxsc: 0,
              xgr: this.$store.state.userInfo.yhid
            }
            this.nextItem(this.currentIndex)
          }
        } else {
          this.$message.error(res.resultDesc)
        }
      }).catch(err => {
        this.$message.error({message: '当前网络卡顿，请刷新后重试', duration: 0})
      })
    } else {
      this.backPath = '/wordcontent?source=' + this.source
      this.nextItem(this.currentIndex)
    }
  },
  methods: {
    updateDrawerSize() {
      const width = window.innerWidth;
      if (width <= 480) {
        this.drawerSize = '100%';
      } else if (width <= 768) {
        this.drawerSize = '90%';
      } else {
        this.drawerSize = '520px';
      }
    },
    //意见反馈
    feedBackFn() {
      this.$refs.handleWrong.dialogVisible = true
    },
    // 打开ai聊天弹框
    openModal() {
      this.showModal = true;
      this.iframeSrc = '/foreignLanguage.html';
    },
    closeModal() {
      this.iframeSrc = '';
    },
    // 题目超出时，点击展示全部
    showAll(val) {
      // var oDom = document.querySelector('.showall')
      // oDom.innerHTML = val
      this.showTip = !this.showTip
    },
    // 看义拼词词义超过一行换行时，改成居左显示
    checkMeanWrap() {
      this.$nextTick(() => {
        const span = this.$el.querySelector('.test2 .mean span')
        if (!span) return
        const lineH = parseFloat(window.getComputedStyle(span).lineHeight)
        const wrapped = lineH > 0 && span.clientHeight > lineH * 1.5
        span.classList.toggle('wrap', wrapped)
      })
    },
    // 收藏
    collect(sfsc) {
      if (this.clickStop) {
        return ''
      }
      this.clickStop = true
      let jxInfo = JSON.parse(sessionStorage.getItem('jxInfo'))
      let data = {
        bbid: Number(this.$route.query.bbid),
        bbmc: JSON.parse(sessionStorage.getItem('bbInfo')).find(ele => {
          if (ele.bbid === Number(this.$route.query.bbid)) {
            return ele
          }
        }).bbmc,
        cjr: this.$store.state.userInfo.yhid,
        dcid: this.currentWord.id,
        dcsy: this.currentWord.cy,
        dyid: Number(this.$route.query.dyid),
        dymc: jxInfo.dymc,
        lxid: this.$route.query.lxid,
        lxmc: this.$route.query.type,
        mc: this.currentWord.nr,
        xgr: this.$store.state.userInfo.yhid,
        xsid: this.$store.state.userInfo.yhid,
        zid: Number(this.$route.query.zid),
        zmc: jxInfo.zmc,
        scbj: sfsc
      }
      updateCollectionWord(data).then(res => {
        if (res.success) {
          this.currentWord.sfsc = !sfsc
          this.wordList[this.currentIndex].sfsc = !sfsc
          sessionStorage.setItem('words', JSON.stringify(this.wordList))
          this.$message.success(sfsc ? '取消成功' : '收藏成功')
          this.clickStop = false
        } else {
          this.$message.warning(res.resultDesc)
        }
      })
    },
    back() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.$router.replace({path: this.backPath})
    },
    // 保存记录到本地
    preserve() {
      if (this.source === 'studyway') {
        this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
        this.submitData.startTime = new Date().getTime()
        // cjlx 任务false集训true
        saveMyBreakpoint({
          cjid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
          cjlx: true,
          ddxx: JSON.stringify(this.submitData),
          dyid: Number(this.$route.query.dyid),
          xsid: this.$store.state.userInfo.yhid
        }).then(res => {
          console.log('学习记录保存数据库成功')
        }).catch(error => {
          this.$message.error({message: '当前网络卡顿，请刷新后重试', duration: 0})
        })
      }
    },
    // 打乱顺序
    shuffle(a, b) {
      return Math.random() > .5 ? -1 : 1
    },
    // 计时开始
    timeStart() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.time = 20
      this.timer = setInterval(() => {
        this.time--
        if (this.time === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.optionSelected = []
          this.content = 'default'
        }
      }, 1000)
    },
    // 发音
    play() {
      this.$refs.audio.play()
    },
    // 进行下一词
    nextItem(index) {
      this.currentWord = this.wordList[index]
      this.content = 'default'
    },
    // 熟悉不熟悉
    isShuxi(sfsx) {
      if (this.clickStop) {
        return ''
      }
      this.clickStop = true
      if (this.source === 'studyway') {
        if (this.submitData.list.length && (this.submitData.list.map((ele) => {
          return ele.dcid
        }).indexOf(this.currentWord.id) !== -1)) {
          // 存过,替换
          this.submitData.list.find(ele => {
            if (ele.dcid === this.currentWord.id) {
              return ele
            }
          }).sfsx = sfsx
        } else {
          // 没存过,新增
          let data = {
            dcid: this.currentWord.id,
            dcmc: this.currentWord.nr,
            lx: this.currentWord.lx,
            sfsx: sfsx
          }
          this.submitData.list.push(data)
        }
      }
      this.content = sfsx ? 'test1' : 'study'
      this.$nextTick(() => {
        this.clickStop = false
      })
    },
    // test1提交
    doTest1(item) {
      if (this.clickStop) {
        return ''
      }
      this.clickStop = true
      this.ansYes = this.currentWord.cy
      clearInterval(this.timer)
      this.timer = null
      if (item === this.currentWord.cy) {
        // 做对了
        if (this.currentWord.lx) {
          if (this.currentIndex + 1 === this.wordList.length) {
            if (this.source === 'studyway') {
              this.submitData.progress = 1
              this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
              this.submitData.startTime = new Date().getTime()
              // cjlx 任务false集训true
              saveMyBreakpoint({
                cjid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
                cjlx: true,
                ddxx: JSON.stringify(this.submitData),
                dyid: Number(this.$route.query.dyid),
                xsid: this.$store.state.userInfo.yhid
              }).then(res => {
                this.content = 'test'
              }).catch(error => {
                this.$message.error({message: '当前网络卡顿，请刷新后重试', duration: 0})
              })
            } else {
              this.content = 'test'
              this.clickStop = false
            }
          } else {
            this.currentIndex++
            this.nextItem(this.currentIndex)
            this.preserve()
            this.clickStop = false
          }
        } else {
          let arr = (this.currentWord.dccf + ',' + this.currentWord.grcfx)
          this.optionAns = arr.split(',').splice(0, 8).sort(() => Math.random() - 0.5)
          this.content = 'test2'
          this.clickStop = false
        }
        this.ansNo = ''
        this.ansYes = ''
      } else {
        // 做错了
        this.ansNo = item
        setTimeout(() => {
          this.content = ''
          this.$nextTick(() => {
            this.ansNo = ''
            this.ansYes = ''
            this.content = 'study'
            this.clickStop = false
          })
        }, 1000)
      }
    },
    // test2点击选项
    selected(data, index) {
      if (this.optionSelected.map((ele) => {
        return ele.index
      }).indexOf(index) === -1) {
        this.optionSelected.push({txt: data, index: index})
      } else {
        this.optionSelected.splice(this.optionSelected.map((ele) => {
          return ele.index
        }).indexOf(index), 1)
      }
    },
    // test2删除选项
    delAll() {
      this.optionSelected = []
    },
    // test2提交答案
    submit() {
      if (this.clickStop) {
        return ''
      }
      this.clickStop = true
      if (this.optionSelected.length === 0) {
        this.$message.warning('请拼写成正确的单词')
        this.clickStop = false
      } else {
        clearInterval(this.timer)
        this.timer = null
        let word = ''
        this.optionSelected.forEach(ele => {
          word += ele.txt
        })
        if (word.toLowerCase() === this.currentWord.nr.toLowerCase()) {
          this.dioAnswer = 'yes1'
          this.$nextTick(() => {
            // this.dialogMsg = true
            if (this.currentIndex + 1 === this.wordList.length) {
              if (this.source === 'studyway') {
                this.submitData.progress = 1
                this.submitData.xxsc = this.submitData.xxsc + parseInt((new Date().getTime() - this.submitData.startTime) / 1000)
                this.submitData.startTime = new Date().getTime()
                // cjlx 任务false集训true
                saveMyBreakpoint({
                  cjid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
                  cjlx: true,
                  ddxx: JSON.stringify(this.submitData),
                  dyid: Number(this.$route.query.dyid),
                  xsid: this.$store.state.userInfo.yhid
                }).then(res => {
                  this.content = 'test'
                }).catch(error => {
                  this.$message.error({message: '当前网络卡顿，请刷新后重试', duration: 0})
                })
              } else {
                this.content = 'test'
              }
            } else {
              this.currentIndex++
              this.nextItem(this.currentIndex)
              this.preserve()
            }
            this.optionSelected = []
            this.dioAnswer = ''
            // this.dialogMsg = false
            this.clickStop = false
          })
        } else {
          this.dioAnswer = 'no1'
          this.$nextTick(() => {
            this.dialogMsg = true
            this.optionAns.sort(this.shuffle)
            setTimeout(() => {
              this.optionSelected = []
              this.timeStart()
              this.dialogMsg = false
              this.clickStop = false
            }, 2000)
          })
        }
      }
    },
    // 去单元测试
    toTest() {
      if (this.source === 'studyway') {
        if (!this.linkClick) {
          return false
        }
        this.linkClick = false
        getMyBreakpoint({
          dyid: ~~this.$route.query.dyid,
          cjid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid,
          xsid: this.$store.state.userInfo.yhid,
          cjlx: 1,
        }).then(res => {
          if (res.success) {
            let notes = res.resultDesc === 'SUCCESS' ? '' : res.resultDesc
            if (notes) {
              let submitData = JSON.parse(notes)
              if (submitData.progress == 1) {
                this.$router.replace({
                  name: 'testpage',
                  query: {
                    type: this.$route.query.type,
                    bbid: this.$route.query.bbid,
                    zid: this.$route.query.zid,
                    zmc: this.$route.query.zmc,
                    dyid: this.$route.query.dyid,
                    source: this.$route.query.source,
                    lxid:this.$route.query.lxid
                  }
                })
              } else {
                this.$message.error('正在保存学习记录，请稍后重试')
                this.linkClick = true
              }
            }
          } else {
            this.$message.error(res.resultDesc)
            this.linkClick = true
          }
        }).catch(err => {
          this.linkClick = true
          this.$message.error('当前网络卡顿，请刷新后重试')
        })
      } else {
        this.$router.replace({name: 'testpage', query: {source: this.source}})
      }
    }
  },
  watch: {
    content(val) {
      this.showTip = false
      switch (val) {
        case 'default':
          this.play()
          break
        case 'study':
          this.play()
          break
        case 'test1':
          this.timeStart()
          this.play()
          break
        case 'test2':
          this.optionSelected = []
          this.timeStart()
          this.checkMeanWrap()
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 0;
}

.showall {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  background: #5990FF;
  color: #fff;
  font-size: 2vw;
  padding: 5px 10px;
  border-radius: 20px;
}

.dialogMsg {
  .dio {
    background: #fff;
    border-radius: 22px;
    padding-top: 20px;

    img {
      display: block;
      margin: 30px auto;
      margin-bottom: 50px;
    }

    .title {
      text-align: center;
      font-size: 30px;
      line-height: 30px;
      margin-bottom: 20px;
    }

    .dioWord {
      text-align: center;
      font-size: 28px;
      line-height: 28px;
      padding-bottom: 30px;
    }
  }
}

.studyBox {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('../../../assets/images/student/learnwords.png') no-repeat;
  background-size: 100% 100%;
  .doumiao {
    position: absolute;
    bottom: 2vh;
    right: 40px;
    width: 200px;
    height: 200px;
    cursor: pointer;
  }

  .huli {
    position: absolute;
    bottom: 2.5vh;
    left: -20px;
    width: 300px;
    height: 200px;
    cursor: pointer;
  }
  .main {
    background: url('../../../assets/images/student/unitBg.png') no-repeat;
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    height: 75%;
    background-size: 100% 100%;
    padding: 4vw;
    padding-bottom: 4vw;



    .unitsTitle {
      width: 50%;
      display: inline-block;
      position: absolute;
      top: -10%;
      left: 50%;
      transform: translateX(-50%);

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        top: 0;
        width: 100%;
        text-align: center;
        color: #000;
        font-size: 1.7vw;
        padding-top: 0.5vw;
      }
    }
  }

  .congratulations {
    width: 34vw;
    height: 25vw;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);

    .image {
      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        bottom: 15%;
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 1.2rem;
      }
    }
  }

  .practice {
    width: 13rem;
    height: 4rem;
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .text {
      position: absolute;
      top: 0;
      text-align: center;
      color: #fff;
      height: 100%;
      width: 100%;
      font-size: 28px;
      line-height: 4rem;
    }
  }

  // 松鼠
  .squirrel {
    position: absolute;
    top: 23%;
    left: 8%;
    width: 8vw;
    height: 6.57vw;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  // 初始
  .default {
    width: 100%;
    height: 100%;

    .progress {
      width: 80%;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 50px;
      ::v-deep  .el-progress {
        width: 100%;
      }

      .text {
        font-size: 1.5vw;
        //position: absolute;
        //right: -6vw;
        //top: -5px;
        text-align: right;
        color: #5990FF;
        padding-left: 10px;

      }
    }

    .word {
      text-align: center;
      height: 23%;
      color: #333;
      font-size: 3vw;
      line-height: 3vw;
      max-width: 92%;
      white-space: nowrap;
      margin: auto;

      &.long {
        font-size: 2.2vw;
        line-height: 2.4vw;
      }

      &.xlong {
        font-size: 1.6vw;
        line-height: 1.8vw;
      }
    }

    .audio {
      width: 100%;
      text-align: center;
      height: 32%;

      img {
        display: block;
        width: 4vw;
        height: 4vw;
        margin: 0 auto;
        cursor: pointer;
      }
    }

    .mean {
      width: 100%;
      height: 23%;
      text-align: center;
      color: #333;
      font-size: 2.5vw;
      line-height: 2.5vw;
      font-family: Arial, Helvetica, sans-serif;
    }

    .btns {
      position: absolute;
      bottom: -.6vw;
      width: 38%;
      left: 50%;
      height: 10%;
      transform: translateX(-50%);

      .btnleft {
        width: 45%;
        height: 100%;
        position: relative;
        cursor: pointer;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }

        .btntext {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 1.6vw;
          color: #fff;
        }
      }

      .btnright {
        width: 48%;
        height: 100%;
        position: relative;
        cursor: pointer;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }

        .btntext {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 1.6vw;
          color: #333;
        }
      }
    }
  }

  //   第一次集训
  .test1 {
    width: 100%;
    height: 100%;

    .header {
      width: 100%;
      height: 20%;
      position: relative;

      .title {
        width: 50%;
        text-align: center;
        margin: auto;
        font-size: 1.9vw;
        color: #333;
      }

      .time {
        position: absolute;
        right: 2vw;
        top: .3vw;
        font-size: 1.7vw;

        span {
          color: #FF4545;
          font-size: 1.8vw;
        }
      }
    }

    .wordaudio {
      width: 100%;
      height: 20%;
      text-align: center;

      .word {
        color: #333;
        // 文字撑开div
        width: fit-content;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        font-size: 2vw;
        position: relative;
        margin: auto;
        max-width: 90%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        .img {
          position: absolute;
          right: 0;
          width: 4vw;
          height: 4vw;
          top: -10px;
          right: -6vw;
          cursor: pointer;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .options {
      width: 100%;
      height: 65%;
      // border: 1px solid red;
      .option {
        position: relative;
        height: 20%;
        margin-bottom: 1%;

        .answer {
          box-sizing: border-box;
          cursor: pointer;
          padding: 1.5% 0;
          width: 50%;
          text-align: center;
          font-size: 1.5vw;
          margin: auto;
          border: 2px solid #FFFFFF;
          border-radius: 10px;
          color: #003333;
          line-height: 1.5vw;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .icon {
            width: 3vw;
            height: 3vw;
            position: absolute;
            top: 0;
            right: -5vw;

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .test2 {
    width: 100%;
    height: 100%;

    .header {
      width: 100%;
      height: 20%;
      position: relative;

      .title {
        width: 50%;
        text-align: center;
        margin: auto;
        font-size: 1.9vw;
        color: #333;
      }

      .time {
        position: absolute;
        right: 2vw;
        top: .3vw;
        font-size: 1.7vw;

        span {
          color: #FF4545;
          font-size: 1.8vw;
        }
      }
    }

    .mean {
      height: 14%;
      text-align: center;
      font-size: 1.5vw;
      line-height: 1.3;
      color: #333;

      span {
        max-width: 90%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        margin: auto;
        cursor: pointer;

        // 换行时居左显示
        &.wrap {
          text-align: left;
        }
      }
    }

    .options2 {
      margin: auto;
      height: 16%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 0.4vw;

      .center {
        width: fit-content;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        position: relative;
        margin: auto;

        .del {
          font-size: 2vw;
          position: absolute;
          right: -3vw;
          display: none;

          i {
            color: #666;
            cursor: pointer;
          }
        }
      }

      .option2 {
        font-size: 2vw;
        float: left;
        padding: 0.5vw;
        background: #5990FF;
        color: #fff;
        border-radius: 6px;
        line-height: 2vw;
        margin-right: 5px;
      }
    }

    .hr {
      width: 40%;
      height: 2px;
      background: #000;
      margin: 0 auto;
    }

    .answers2 {
      padding-top: 15px;
      width: 50%;
      height: 49%;
      margin: 0 auto;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: flex-start;
      gap: 10px !important;

      .answer2 {
        width: auto;
        min-width: 22%;
        height: 4vw;
        line-height: 4vw;
        padding: 0 0.6vw;
        font-size: 1.5vw;
        float: none;
        text-align: center;
        border: 2px solid #FFFFFF;
        border-radius: 6px;
        cursor: pointer;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-left: 0;
        white-space: nowrap;
      }

      .answer2.selected {
        background: #5990FF;
        border: 1px solid #5990FF;
        color: #fff;
      }
    }

    .btns {
      position: absolute;
      bottom: -.6vw;
      width: 15%;
      left: 50%;
      height: 10%;
      transform: translateX(-50%);

      img {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      span {
        position: absolute;
        top: 48%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.6vw;
        color: #fff;
        cursor: pointer;
      }
    }
  }

  .study {
    width: 100%;
    height: 100%;

    .progress {
      height: 10%;
      width: 70%;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      ::v-deep  .el-progress {
        width: 100%;
      }

      .text {
        text-align: right;
        font-size: 1.5vw;
        color: #5990FF;
      }
    }

    .wordaudio {
      width: 100%;
      height: 17%;
      text-align: center;

      .word {
        color: #333;
        // 文字撑开div
        width: fit-content;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        font-size: 2.5vw;
        position: relative;
        margin: auto;

        .img {
          position: absolute;
          right: 0;
          width: 4vw;
          height: 4vw;
          top: -7px;
          right: -6vw;
          cursor: pointer;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .overprint {
      width: 100%;
      height: 13%;
      text-align: center;
      color: #333;
      font-size: 2vw;
      line-height: 2vw;
    }

    .mean {
      width: 80%;
      height: 60%;
      border: 2px solid #000000;
      border-radius: 20px;
      margin: auto;
      position: relative;

      .menuoptions {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
        width: 100%;
        height: 90%;
        padding: 2% 6%;
        box-sizing: border-box;

        .every {
          color: #333;
          font-size: 1.5vw;
          line-height: 2.6vw;
          margin-bottom: 20px;
          word-break: break-word;

          .topfoue {
            width: 100%;
            max-width: 100%;
            text-align: left;

            p {
              margin-bottom: 0.8vw;
            }
          }

          .association {
            line-height: 2.6vw;
          }
        }
      }
    }

    .btns {
      position: absolute;
      bottom: -.6vw;
      width: 15%;
      left: 50%;
      height: 10%;
      transform: translateX(-50%);

      img {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      span {
        position: absolute;
        top: 48%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.6vw;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
/* ========== 平板端适配样式 ========== */
@media screen and (min-width: 701px) and (max-width: 1366px) {
  .studyBox {
    .main {
      background: none !important;
    }

    .doumiao {
      width: 130px !important;
      height: 130px !important;
    }

    .huli {
      width: 170px !important;
      height: 115px !important;
    }

    .study {
      .progress {
        width: 80% !important;
        margin-top: -2vw !important;
        align-items: center !important;

        .text {
          font-size: 1.5vw !important;
          line-height: 1 !important;
          padding-left: 10px !important;
        }
      }

      .wordaudio .word {
        font-size: 3.2vw !important;

        .img {
          width: 2.8vw !important;
          height: 2.8vw !important;
          right: -3.6vw !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
        }
      }
    }

    .test1 {
      margin-top: -3.5vw !important;

      .wordaudio {
        margin-top: -2vw !important;

        .word {
          font-size: 3vw !important;
          transform: translateX(-1.8vw) !important;

          .img {
            width: 2.8vw !important;
            height: 2.8vw !important;
            right: -3.6vw !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
          }
        }
      }

      .options .option {
        height: auto !important;
        margin-bottom: 2% !important;

        .answer {
          width: 85% !important;
          font-size: 2.2vw !important;
          padding: 1.6% 4% !important;
          line-height: 1.3 !important;
          text-align: left !important;
          white-space: normal !important;
          overflow: visible !important;
          text-overflow: clip !important;
          word-break: break-word !important;

          .icon {
            display: none !important;
          }
        }
      }
    }

    .test2 {
      margin-top: -3vw !important;

      .mean {
        font-size: 2.1vw !important;
        line-height: 1.3 !important;
      }

      .option2 {
        font-size: 2.9vw !important;
        line-height: 2.9vw !important;
      }

      .answers2 {
        width: 82% !important;
        display: flex !important;
        flex-wrap: wrap !important;
        justify-content: flex-start !important;
        align-content: flex-start !important;
        gap: 1.6vw 1vw !important;
      }

      .answers2 .answer2 {
        font-size: 2.7vw !important;
        width: auto !important;
        min-width: calc((100% - 3vw) / 4) !important;
        height: auto !important;
        min-height: 5vw !important;
        line-height: 1.2 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        float: none !important;
        margin: 0 !important;
        padding: 0.4vw 0.3vw !important;
        box-sizing: border-box !important;
        white-space: normal !important;
        word-break: break-word !important;
      }
    }
  }

  .congratulations {
    width: 44vw !important;
    height: 32vw !important;

    .image .text {
      font-size: 1.8vw !important;
      bottom: 12% !important;
      white-space: nowrap !important;
    }
  }
}

/* ========== 电脑端：中文选项答案换行显示 ========== */
@media screen and (min-width: 1367px) {
  .studyBox .test1 .options {
    overflow-y: auto !important;
  }

  .studyBox .test1 .options .option {
    height: auto !important;
    margin-bottom: 1.5% !important;

    .answer {
      width: 60% !important;
      padding: 1% 3% !important;
      line-height: 1.3 !important;
      text-align: left !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;

      .icon {
        display: none !important;
      }
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 700px) {
  .studyBox {
    .doumiao {
      width: 100px !important;
      height: 100px !important;
      right: 15px !important;
    }

    .huli {
      width: 120px !important;
      height: 80px !important;
      left: -10px !important;
    }

    .main {
      width: 87% !important;
      height: 70% !important;
      top: 50% !important;
      padding: 8vw 4vw !important;
      background: rgba(255, 255, 255, 0.95) !important;
      border-radius: 20px !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;

      .unitsTitle {
        width: 70% !important;
        top: -8% !important;

        .text {
          font-size: 14px !important;
          padding-top: 6px !important;
        }
      }

      .squirrel {
        width: 40px !important;
        height: 60px !important;
        top: 15% !important;
      }
    }

    .default {
      .progress {
        display: flex;
        justify-content: center;
        align-items: center;
        .text {
          font-size: 18px !important;
          right: -16vw !important;
          top: -1px;
        }
      }

      .word {
        font-size: 28px !important;
        max-width: 92% !important;
        padding-top: 20px;

        &.long {
          font-size: 22px !important;
          line-height: 1.2 !important;
        }

        &.xlong {
          font-size: 16px !important;
          line-height: 1.2 !important;
        }
      }

      .audio {
        img {
          width: 40px !important;
          height: 40px !important;
        }
      }

      .mean {
        font-size: 25px !important;
        line-height: 7vw !important;
      }

      .btns {
        width: 70% !important;
        bottom: -2vw !important;

        .btnleft .btntext,
        .btnright .btntext {
          font-size: 14px !important;
        }
      }
    }

    .study {
      .progress{
        height: 16%;
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .progress .text {
        font-size: 18px !important;
      }
      .wordaudio .word {
        font-size: 28px !important;

        .img {
          width: 32px !important;
          height: 32px !important;
          right: -40px !important;
        }
      }

      .overprint {
        font-size: 16px !important;
      }

      .mean {
        width: 90% !important;

        .menuoptions {
          padding: 12px 16px;
        }

        .menuoptions .every {
          font-size: 16px !important;
          line-height: 26px !important;

          .topfoue {
            padding-bottom: 10px;

            p {
              margin-bottom: 8px;
            }
          }

          .association {
            line-height: 26px !important;
          }
        }
      }

      .btns {
        width: 35% !important;

        span {
          font-size: 14px !important;
        }
      }
    }

    .test1 {
      .header {
        .title {
          font-size: 16px !important;
        }

        .time {
          font-size: 14px !important;

          span {
            font-size: 16px !important;
          }
        }
      }

      .wordaudio .word {
        font-size: 28px !important;

        .img {
          width: 32px !important;
          height: 32px !important;
          right: -40px !important;
        }
      }

      .options .option {
        height: auto !important;
        margin-bottom: 10px !important;

        .answer {
          width: 80% !important;
          font-size: 16px !important;
          padding: 10px 14px !important;
          line-height: 1.4 !important;
          height: auto !important;
          text-align: left !important;
          white-space: normal !important;
          overflow: visible !important;
          text-overflow: clip !important;
          word-break: break-word !important;
          border: 2px solid #5990ff !important;
        }
      }
    }

    .test2 {
      .header {
        .title {
          font-size: 16px !important;
        }

        .time {
          font-size: 14px !important;

          span {
            font-size: 16px !important;
          }
        }
      }

      .mean {
        font-size: 22px !important;
        line-height: 1.3 !important;
      }

      .options2 {
        .option2 {
          font-size: 20px !important;
          padding: 6px 12px !important;
          line-height: 4vw !important;
        }

        .center .del {
          font-size: 20px !important;
          right: -30px !important;
        }
      }

      .answers2 {
        width: 90% !important;

        .answer2 {
          font-size: 22px !important;
          height: 40px !important;
          line-height: 40px !important;
          width: auto !important;
          padding: 0 12px;
          border: 2px solid #5990ff !important;
        }
      }

      .btns {
        width: 35% !important;

        span {
          font-size: 14px !important;
        }
      }
    }

    .practice {
      width: 120px !important;
      height: 40px !important;

      .text {
        font-size: 16px !important;
        line-height: 40px !important;
      }
    }

    .congratulations {
      width: 70% !important;
      height: auto !important;

      .image .text {
        font-size: 12px !important;
        bottom: 12% !important;
      }
    }
  }
  .el-drawer {
    ::v-deep  .el-drawer__header {
      padding: 12px 15px;
      margin-bottom: 0;

      span {
        font-size: 16px;
      }
    }

    ::v-deep  .el-drawer__body {
      padding: 0;
    }

    ::v-deep  iframe {
      width: 100% !important;
      height: 100% !important;
    }
  }
}

@media screen and (max-width: 480px) {
  .studyBox {
    .main {
      width: 93% !important;
      padding: 10vw 3vw !important;
      background: rgba(255, 255, 255, 0.96) !important;
      border-radius: 16px !important;

      .squirrel {
        width: 70px !important;
        height: 70px !important;
        top: 15% !important;
        left: -2%;
      }
    }

    .default {
      .progress {
        .text {
          font-size: 18px !important;
          right: -14vw !important;
          top: -1px;
        }
      }
      .word {
        font-size: 28px !important;
        padding-top: 20px;

        &.long {
          font-size: 20px !important;
          line-height: 1.2 !important;
        }

        &.xlong {
          font-size: 14px !important;
          line-height: 1.2 !important;
        }
      }

      .mean {
        font-size: 20px !important;
      }

      .btns {
        width: 85% !important;
      }
    }

    .study {
      .wordaudio .word {
        font-size: 26px !important;
      }

      .btns {
        width: 45% !important;
      }

      .mean {
        .menuoptions {
          padding: 10px 14px;
        }

        .menuoptions .every {
          font-size: 15px !important;
          line-height: 24px !important;
        }

        .topfoue {
          padding-bottom: 10px;
        }
      }
    }

    .test2 .answers2 .answer2 {
      width: auto !important;
      padding: 0 10px !important;
      font-size: 20px !important;
      border: 2px solid #5990ff !important;
    }
  }
}
</style>
<style lang="scss">
.studymain {
  .studyBox {
    .progress {
      .el-progress {
        width: 70%;
        margin: auto;
      }

      .el-progress-bar__inner {
        background: linear-gradient(251deg, #3862D9, #4EB7FB);
      }

      .el-progress-bar__outer {
        height: 20px !important;

        .el-progress-bar__innerText {
          display: none;
        }
      }
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-thumb {
      background: #87C2EF;
      border-radius: 20px;
    }

  }

  .dialogMsg {
    .el-dialog {
      width: 400px;
      border-radius: 22px;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 18px 14px 18px;
      // background: #daffa5;
      background: #4cb2f1;
      border-radius: 22px;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 80%;
    max-width: 1000px;
  }

  iframe {
    border: none;
  }
}
@media screen and (max-width: 768px) {
  .dialogMsg {
    .el-dialog {
      width: 85% !important;
      max-width: 320px !important;
    }

    .el-dialog__body {
      padding: 15px 12px !important;
    }

    .dio {
      img {
        width: 80px !important;
        margin: 20px auto !important;
      }

      .title {
        font-size: 20px !important;
        line-height: 20px !important;
      }

      .dioWord {
        font-size: 18px !important;
        line-height: 24px !important;
        padding-bottom: 20px !important;
      }
    }
  }

  .el-drawer {
    width: 100% !important;
    max-width: 100%;

    &__wrapper {
      .el-drawer {
        width: 100% !important;
        border-radius: 0 !important;
      }
    }
  }

  /* 确保 iframe 在抽屉内正确显示 */
  .el-drawer__body {
    padding: 0 !important;
    overflow: hidden !important;

    iframe {
      width: 100% !important;
      height: 100% !important;
      border: none;
    }
  }
}
</style>
